import { NextImage } from "@ecco/ui/next-image";
import type { NavigationMedia } from "@lib/contentful/mappers/mapNavigation";

export const FallbackImageNavigation = ({ image }: { image?: NavigationMedia }) => {
    if (!image) return null;

    return (
        <NextImage
            priority={true}
            objectFit={"cover"}
            layout="responsive"
            src={image.url}
            alt={image.alt}
            sizes={["50vw"]}
        ></NextImage>
    );
};
